import axios from 'axios';
import {backendHost} from '../../config';

export const getMailingStatisticsCountReplenishment = (params) => {
    return axios.get(`${backendHost}/api/admin/v2/mailing/statistics/deposits/count`, {params});
};